import React from 'react';
import { Wallet, TrendingUp, Landmark } from 'lucide-react';

const StatCard = ({ title, value, icon: Icon, color, bgColor }) => (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4 transition-all hover:shadow-md">
        <div className={`${bgColor} p-3 rounded-lg`}>
            <Icon className={color} size={24} />
        </div>
        <div>
            <p className="text-sm font-medium text-gray-500">{title}</p>
            <h3 className="text-2xl font-bold text-gray-900 mt-1">{value}</h3>
        </div>
    </div>
);

const PettyCashStats = ({ stats }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <StatCard
                title="Available Balance"
                value={`₹${stats?.availableBalance?.toLocaleString() || '0'}`}
                icon={Wallet}
                color="text-sm-primary"
                bgColor="bg-purple-50"
            />
            <StatCard
                title="Total Spent"
                value={`₹${stats?.totalSpent?.toLocaleString() || '0'}`}
                icon={TrendingUp}
                color="text-sm-accent"
                bgColor="bg-orange-50"
            />
            <StatCard
                title="Total Allocated"
                value={`₹${stats?.totalAllocated?.toLocaleString() || '0'}`}
                icon={Landmark}
                color="text-blue-600"
                bgColor="bg-blue-50"
            />
        </div>
    );
};

export default PettyCashStats;
